module.exports = __webpack_public_path__ + "static/media/italy.604345b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flag/italy.svg
// module id = 429
// module chunks = 120